import { useMemo } from 'react';
import type { VoidFunctionComponent } from 'react';

import { plural } from '../../../../../shared/helpers';
import { Badge, BadgeColors } from '../../../generic';
import { DetailsPanelList } from '../../../generic/DetailsPanel';
import MiniPercentageBar from '../../../generic/MiniPercentageBar';
import type { SnippetDetails } from '../../../../../shared/snippets';

import DetailsSection from './DetailsSection';

import styles from './MatchConfidence.module.less';

type Props = {
  snippet: SnippetDetails;
};

/**
 * The Match Confidence drawer details.
 */
const MatchConfidence: VoidFunctionComponent<Props> = ({ snippet }) => {
  const rows = useMemo(() => {
    return [
      {
        label: 'Percentage of matching code',
        content: (
          <MiniPercentageBar percent={Math.round(snippet.highestMatchPercentage * 100)} />
        ),
      },
      {
        label: 'Number of matching files',
        content: (
          <span>
            {snippet.matchCount}
          </span>
        ),
      },
      {
        label: 'Potential version matches',
        content: (
          <span>
            {snippet.matchCount}
          </span>
        ),
      },
      {
        label: 'Other versions of this package',
        content: (
          <span className={styles.otherVersions}>
            {snippet.otherVersions.length === 0 ? <span className="italic">(No other versions)</span> : (
              snippet.otherVersions.map((otherVersion) => (
                <span key={otherVersion.version}>
                  {otherVersion.version}&nbsp;
                  <Badge color={BadgeColors.LightGray}>
                    {otherVersion.matchCount} {plural(otherVersion.matchCount, 'file', 'files')}
                  </Badge>
                </span>
              ))
            )}
          </span>
        ),
      },
    ];
  }, [snippet]);

  return (
    <DetailsSection heading="Match Confidence">
      <DetailsPanelList rows={rows} />
    </DetailsSection>
  );
};

export default MatchConfidence;
